import { makeHttpRequest } from "@/shared";

export const readEvent = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/events/read/${id}`,
            method: "POST",
        })
    ).data;

    return response.data;
};
